import { z } from "zod";

// Schema for the TaxRate model
const TaxRateSchema = z
  .object({
    taxRateId: z.number().nullable().optional().readonly(),
    // TODO: Reinstate .uuid() validation once mock data or server-side generation provides valid UUIDs.
    guid: z.string().nullable().optional().readonly(),
    number: z.number().nullable().optional().readonly(), // Kept as string as per model
    name: z
      .string()
      .min(1, { message: "Tax rate name cannot be empty" })
      .readonly(),
    importId: z.string().nullable().optional().readonly(),
    type: z.enum(["Percent", "Fixed", "Tax Table"]).readonly(),
    disabled: z.boolean().default(false).readonly(),
    rate: z
      .number()
      .min(0, { message: "Rate cannot be negative" })
      .default(0)
      .readonly(),
    default: z.boolean().default(false).readonly(), // 'default' is a keyword, but z.object allows it as a key
    takeoutTaxEnabled: z.boolean().default(false).readonly(),
    takeoutTaxRate: z.number().min(0).nullable().optional().readonly(), // Rate should be non-negative
    roundingOptions: z
      .enum([
        "Half Even Rounding",
        "Half Up Rounding",
        "Always Round Down",
        "Always Round Up",
      ])
      .readonly(),
    createdAt: z.date().nullable().optional().readonly(), // Firestore server timestamp
    updatedAt: z.date().nullable().optional().readonly(), // Firestore server timestamp
  })
  .strict();

export type TaxRateType = z.infer<typeof TaxRateSchema>;

export default TaxRateSchema;
